import React from 'react';
import { Card, Table } from 'react-bootstrap';
import dateformat from 'utils/dateformat';
import { useAppTheme } from '../../../../contexts/ThemeContext';
import {
  getTableHeaderClass,
  getModernDataTableClass,
  getModernCardHeaderClass,
  getModernCardBodyClass,
  getModernTableClass,
} from 'utils/tableTheme';

const Results = (props) => {
  const { data, title } = props;
  const currentTheme = useAppTheme();

  return (
    <div className="results-root">
      {data.length > 0 ? (
        <Card
          className={getModernDataTableClass(currentTheme)}
        >
          <Card.Header
            className={getModernCardHeaderClass(currentTheme)}
          >
            {title}
          </Card.Header>
          <Card.Body
            className={getModernCardBodyClass(currentTheme)}
          >
            <Table
              style={{ fontSize: "0.9rem" }}
              hover
              responsive
              size="sm"
              className={getModernTableClass(currentTheme)}
            >
              <thead>
                <tr className={getTableHeaderClass(currentTheme)}>
                  <th className="text-center col-sm-1">SERIAL</th>
                  <th className="text-center">SOFTWARE</th>
                  <th className="text-center">DATA</th>
                  <th className="text-center">E-MAIL</th>
                  <th className="text-center">ENDEREÇO</th>
                  <th className="text-center">LATITUDE</th>
                  <th className="text-center">LONGITUDE</th>
                </tr>
              </thead>
              <tbody>
                {data.map((item) => (
                  <tr key={item._id}>
                    <td className="text-center">{item?.serialnumber || '--'}</td>
                    <td className="text-center">{item?.versaosw || '--'}</td>
                    <td className="text-center">{item?.createdAt ? dateformat(item.createdAt, "UTC:dd/mm/yy' 'HH:MM") : '--'}</td>
                    <td className="text-center">{item?.email || '--'}</td>
                    <td className="text-center">{item?.address || '--'}</td>
                    <td className="text-center">{item?.lat || '--'}</td>
                    <td className="text-center">{item?.lng || '--'}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Card.Body>
        </Card>
      ) : (
        <h3 className="text-center">Sem Dados Registrados!</h3>
      )}
    </div>
  );
};

export default Results;
